import { mapGetters } from 'vuex';
import { ACTION_NAMES } from '@/App.vue';

export default {
  computed: {
    ...mapGetters(['isPortrait']),
  },
  mounted() {
    this.$root.$on(ACTION_NAMES.PREV, this.goPrev);
    this.$root.$on(ACTION_NAMES.NEXT, this.goNext);
  },
  beforeDestroy() {
    this.$root.$off(ACTION_NAMES.PREV, this.goPrev);
    this.$root.$off(ACTION_NAMES.NEXT, this.goNext);
  },
  methods: {
    goPrev() {
      this.goToPrevSlide();
    },
    goNext() {
      this.goToNextSlide();
    },
    goToPrevSlide() {
      const { prev } = this.$route.meta;
      if (prev) {
        this.$router.push(prev);
      }
      this.clearBlur();
    },
    goToNextSlide() {
      const { next } = this.$route.meta;
      if (next) {
        this.$router.push(next);
      }
      this.clearBlur();
    },
    clearBlur() {
      if (document.activeElement) {
        document.activeElement.blur();
      }
    },
  },
};
